import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { ModalAgregarProductoComponent } from '../modales/modal-agregar-producto/modal-agregar-producto.component';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'mmax-helpfootbar',
  templateUrl: './helpfootbar.component.html',
  styleUrls: ['./helpfootbar.component.scss']
})

export class HelpfootbarComponent implements OnInit {
  @Input('mode') modo: string;
  constructor(private modal: ModalService, private EcommerceGenericoService: EcommerceGenericoService) {
    this.modo = this.modo || 'normal'
    this.logoformobile = '../../assets/logo/logo.png';
    this.soporteimg = "../../assets/misc/splash-sup.png";
  }

  ngOnInit(): void {
    this.modo = this.modo || 'normal'
  }

  arrepentimiento() {
    this.modal.open('modal-no-implemented')
  }

  get mailAtencionAlCliente(){
    return this.EcommerceGenericoService.getmailAtencionAlCliente();
  }

  logoformobile: string;
  soporteimg: string;
}
